import React from 'react'
import styled from 'styled-components'
import { Logo } from '../common'
import { Canvas } from '../common/page/Canvas'
import { Borders, Colors, Fonts } from '../constants'

export const SHOW_MAINTENANCE = false

export function CountryBlocker() {
  return (
    <Container>
      <CanvasStyled />
      <Content>
        <LogoStyled />
        <Heading>Integral is not available in your region.</Heading>
        <Description>
          <p>It is prohibited to access or use our services (including Integral and ITGR) if you</p>
          <ul>
            <li>are subject to any US, UK, EU, and UN sanctions;</li>
            <li>reside in a US, UK, EU, or UN-embargoed country;</li>
            <li>
              or, are located, incorporated or otherwise established in, or a citizen or resident of, any of the
              following countries:
            </li>
          </ul>
        </Description>
        <List>
          <li>🇧🇾 Belarus</li>
          <li>🇨🇬 Congo (Brazzaville)</li>
          <li>🇨🇩 Congo (Kinshasa)</li>
          <li>🇨🇮 Côte d'Ivoire (Ivory Coast)</li>
          <li>🇨🇳 People's Republic of China</li>
          <li>🇨🇺 Cuba</li>
          <li>🇪🇹 Ethiopia</li>
          <li>🇮🇷 Iran</li>
          <li>🇮🇶 Iraq</li>
          <li>🇱🇧 Lebanon</li>
          <li>🇱🇾 Libya</li>
          <li>🇰🇵 North Korea</li>
          <li>🇲🇱 Mali</li>
          <li>🇲🇲 Myanmar (Burma)</li>
          <li>🇳🇮 Nicaragua</li>
          <li>🇸🇴 Somalia</li>
          <li>🇸🇸 South Sudan</li>
          <li>🇸🇩 Sudan</li>
          <li>🇸🇾 Syria</li>
          <li>🇺🇸 United States of America</li>
          <li>🇻🇪 Venezuela</li>
          <li>🇾🇪 Yemen</li>
          <li>🇿🇼 Zimbabwe</li>
          <li>Crimea</li>
          <li>Donetsk People's Republic</li>
          <li>Luhansk People's Republic</li>
        </List>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100vh;
  background-color: ${Colors.Background};
`

const CanvasStyled = styled(Canvas)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
`

const Content = styled.div`
  margin: 60px 30px 0 30px;
  padding: 30px;
  max-width: 750px;
  text-align: center;
  color: ${Colors.White};
  background-color: #272b31;
  border: 1px solid #5c5c5c;
  border-radius: ${Borders.Radius};
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  z-index: 1;
`

const LogoStyled = styled(Logo)`
  width: 200px;
`

const Heading = styled.h1`
  font-size: 20px;
  font-family: ${Fonts.Header};
`

const Description = styled.div`
  font-size: 15px;
  text-align: left;

  a {
    color: ${Colors.White};
  }
`

const List = styled.ul`
  font-size: 15px;
  text-align: left;
  list-style: none;
`
